import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { ApiExError } from '@shared';


const initialUsageAnalyticsState: UsageAnalyticsState = {
  data: null,
  isLoading: false,
  errorMessage: null,
};

const usageAnalyticsSlice = createSlice({
  name: 'usageAnalytics',
  initialState: initialUsageAnalyticsState,
  reducers: {
    // Fetch Usage Data Actions
    fetchUsageDataByAdvisorIdRequest(
      state,
      action: PayloadAction<{ advisorId: string }>,
    ) {
      state.isLoading = true;
      state.errorMessage = null;
    },
    fetchUsageDataByAdvisorIdResponse(
      state,
      action: PayloadAction<UsageData>,
    ) {
      state.isLoading = false;
      state.data = action.payload;
      state.errorMessage = null;
    },
    fetchUsageDataByAdvisorIdFailure(
      state,
      action: PayloadAction<ApiExError>,
    ) {
      state.isLoading = false;
      state.errorMessage = action.payload.message;
    },

    // Clear action
    clearUsageData(state) {
      state.data = null;
      state.isLoading = false;
      state.errorMessage = null;
    },
  },
});

export const {
  fetchUsageDataByAdvisorIdRequest,
  fetchUsageDataByAdvisorIdResponse,
  fetchUsageDataByAdvisorIdFailure,
  clearUsageData,
} = usageAnalyticsSlice.actions;

export const usageAnalyticsReducer = usageAnalyticsSlice.reducer;


